<template>
  <el-container>
    <el-main>
      <slot>
        <el-empty description="No access"></el-empty>
      </slot>
    </el-main>
  </el-container>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "NoAuth",
});
</script>
